import React from 'react';

import { Avatar } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { SmallestSizeCSS, SmallerSizeCSS, SmallSizeCSS, ImageSizesCSS, GutterCSS, IconSizesCSS } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { monk2xSrc } from 'constants/icons';

export const SmallestAvatar = styled(Avatar)`
  ${SmallestSizeCSS};
`;

export const SmallerAvatar = styled(Avatar)`
  ${SmallerSizeCSS}
`;

export const SmallAvatar = styled(Avatar)`
  ${SmallSizeCSS}
`;

export const DefaultAvatar = styled(Avatar)`
  width: 60px;
  height: 60px;

  ${(props) => props.theme.breakpoints.up('lg')} {
    width: 80px;
    height: 80px;
  }
`;

export const BigAvatar = styled(Avatar)`
  width: 120px;
  height: 120px;

  ${(props) => props.theme.breakpoints.up('lg')} {
    width: 150px;
    height: 150px;
  }
`;

export const BorderAvatar = styled(Avatar)`
  &.MuiAvatar-root {
    border: 1px solid ${(props) => props.borderColor || props.theme.palette.text.primary};
    background-color: ${(props) => props.borderColor || props.theme.palette.text.primary};
  }
`;

export const StyledBorderAvatar = styled(StyledAvatar)`
  ${({ showBorder, theme }) =>
    showBorder &&
    css`
      border: 2px solid ${theme.palette.green.main};
      background-color: ${theme.palette.green.main};
    `}
  box-sizing: border-box;
`;

export const ColoredAvatar = styled(Avatar)`
  background-color: ${(props) => props.color || props.theme.palette.grey[100]};
  color: ${(props) =>
    props.fontColor ? getColorFromKey(props.fontColor) : props.color ? 'white' : props.theme.palette.text.primary};
  ${(props) => props.size && IconSizesCSS[props.size]};
  ${(props) =>
    props.fontSize &&
    css`
      font-size: ${props.fontSize};
    `}
`;

// this is the latest code, earlier I was explicitly using SmallAvatar, BigAvatar
// also this styledAvatar would have a right gutter
export function StyledAvatar({ src, size, rightGutter, leftGutter, bottomGutter, opacity, ...props }) {
  return (
    <AvatarContainer
      size={size}
      leftGutter={leftGutter}
      rightGutter={rightGutter}
      bottomGutter={bottomGutter}
      src={src}
      opacity={opacity}
      {...props}
    />
  );
}

export function StyledAvatarPlaceholder({
  // src,
  size,
  rightGutter,
  leftGutter,
  bottomGutter,
  // opacity,
  children,
  ...props
}) {
  return (
    <AvatarContainer
      size={size}
      leftGutter={leftGutter}
      rightGutter={rightGutter}
      bottomGutter={bottomGutter}
      // src={src}
      // opacity={opacity}
      {...props}
    >
      {children}
    </AvatarContainer>
  );
}

// TODO: add a default src
StyledAvatar.defaultProps = {
  size: 'medium',
  leftGutter: false,
  rightGutter: false,
};

StyledAvatar.propTypes = {
  leftGutter: PropTypes.bool,
  rightGutter: PropTypes.bool,
  // size: PropTypes.oneOf(ImageSizesCSS.keys)
};

export function MonkAvatar({ size, rightGutter, ...props }) {
  return <StyledMonkAvatar rightGutter={rightGutter} size={size} src={monk2xSrc} {...props} />;
}

const AvatarContainer = styled(Avatar)`
  ${(props) => ImageSizesCSS[props.size]};
  ${GutterCSS};
  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
  ${(props) =>
    props.opacity &&
    css`
      opacity: ${props.opacity};
    `};
  ${(props) =>
    props.padding &&
    css`
      padding: ${props.padding};
    `};
  ${(props) =>
    props.border &&
    css`
      border: ${props.border};
    `};
  ${(props) =>
    !props.variant &&
    css`
      img {
        border-radius: 50%;
      }
    `};
  ${(props) =>
    props.background &&
    css`
      background-color: ${getColorFromKey(props.background)};
    `};
  ${(props) =>
    props.color &&
    css`
      color: ${getColorFromKey(props.color)};
    `};
`;

const StyledMonkAvatar = styled(AvatarContainer)`
  padding: ${(props) => props.theme.spacing(0.5)}rem;
  background: white;
  img {
    object-fit: contain;
  }
  border: 1px solid ${(props) => props.theme.palette.text.secondary};
`;
